import React from 'react';

// Skeleton for Stats Cards
export const StatsCardSkeleton: React.FC = () => {
  return (
    <div className="card card-flush h-100">
      <div className="card-body d-flex flex-column justify-content-between p-6">
        <div className="placeholder-glow">
          <span className="placeholder col-8 mb-3"></span>
          <span className="placeholder col-12 placeholder-lg mb-2"></span>
          <span className="placeholder col-6"></span>
        </div>
      </div>
    </div>
  );
};

// Skeleton for Charts
export const ChartSkeleton: React.FC = () => {
  return (
    <div className="card card-flush h-100">
      <div className="card-header pt-7">
        <div className="placeholder-glow w-100">
          <span className="placeholder col-6"></span>
        </div>
      </div>
      <div className="card-body d-flex align-items-center justify-content-center" style={{ minHeight: '350px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>

            <div className="table-responsive mt-3">
          <table className="table table-row-bordered table-row-dashed gy-4">
            <tbody>
              {Array.from({ length: 4 }).map((_, index) => (
                <tr key={index} className="placeholder-glow">
                  <td><span className="placeholder col-7"></span></td>
                  <td><span className="placeholder col-5"></span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Skeleton for Tables
export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => {
  return (
    <div className="card card-flush h-100">
      <div className="card-header pt-7">
        <div className="placeholder-glow w-100">
          <span className="placeholder col-4"></span>
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-row-bordered gy-4">
            <thead>
              <tr className="placeholder-glow">
                <th><span className="placeholder col-10"></span></th>
                <th><span className="placeholder col-10"></span></th>
                <th><span className="placeholder col-10"></span></th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }).map((_, index) => (
                <tr key={index} className="placeholder-glow">
                  <td><span className="placeholder col-8"></span></td>
                  <td><span className="placeholder col-6"></span></td>
                  <td><span className="placeholder col-7"></span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Small table skeleton for priority/performance tables
export const SmallTableSkeleton: React.FC = () => {
  return (
    <div className="card card-flush h-100">
      <div className="card-body p-5">
        <div className="placeholder-glow mb-3">
          <span className="placeholder col-8 mb-3"></span>
        </div>
    
      </div>
    </div>
  );
};
